<template>
	<v-container grid-list-xl grid-list-lg>
		<v-layout justify-center >
			<v-flex xs12 lg12  md12>
				<v-card width="100%" >
					<v-container >
						<v-layout wrap>
							<v-flex v-for="(filesrc, index) in filesrcs" :key="index" xs12 lg6 md4>
								<v-card  @click="downloadWith(filesrc.path, filesrc.file_name)">
									<v-list>
										<v-list-item>
											<v-list-item-title class="black--text">{{filesrc.file_name}}</v-list-item-title>
											<v-list-item-icon>
												<v-icon class="primary--text">mdi-download</v-icon>
											</v-list-item-icon>
										</v-list-item>
									</v-list>
								</v-card>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
 export default {
  name: "FilesInDocument",
	 props:{
   filesrcs:{
    type:Array
   }
	 },
	 methods:{
   forceFileDownload(response, title) {
    const link = document.createElement('a')
    link.href = response
	   link.target = '_blank'
    link.setAttribute('download', title)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
   },
   downloadWith(url,title){
				this.forceFileDownload(url,title)
   }
	 },
 }
</script>

<style scoped>

</style>